export const customInvoiceCategoryOptions = isForChargeback => {
  return isForChargeback
    ? { Chargeback: 'Chargeback' }
    : {
        Chargeback: 'Chargeback',
        PlatformServices: 'Professional services'
      }
}
